const statusSymbol = Symbol('status');
const valueSymbol = Symbol('value');
const rejectSymbol = Symbol('reject');
export function spyOnPromise(cb) {
    const originalResolve = Promise.resolve;
    const originalReject = Promise.reject;
    try {
        Promise.resolve = function (value) {
            const res = originalResolve.call(Promise, value);
            res[valueSymbol] = value;
            res[statusSymbol] = 'resolved';
            return res;
        };
        Promise.reject = function (value) {
            const res = originalReject.call(Promise, value);
            res[rejectSymbol] = value;
            res[statusSymbol] = 'rejected';
            return res;
        };
        cb({ statusSymbol, rejectSymbol, valueSymbol });
    }
    finally {
        Promise.resolve = originalResolve;
        Promise.reject = originalReject;
    }
}
//# sourceMappingURL=spyOnPromise.js.map